import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap';
import Spinner1 from './spinners';
import moment from 'moment'
import useManageLabRequests from '../../hooks/patientDashboard/usemanageLabrequests';
import { truncateText } from '../../utils/utilities';

const LabRequestHistorySidebar = () => {
    const {handleFechLabRequestsAlt, requests, loading} = useManageLabRequests()

    useEffect(() => {
      handleFechLabRequestsAlt()
    }, [])
    
    console.log("console",requests)

  return (
    <Col xl="" className="d-none app-sideba d-xl-block">

        <hr className="my-3 mt-5 opacity-0" />
        <h5 className={` section-title`}>Recent Lab Requests</h5>
           
            {
                loading ? ( <div className="w-100 d-flex justify-content-center"><Spinner1 /></div> ) :

               !loading && !requests?.length?
            
            <div className='w-100 d-flex justify-content-center'>No Result Found</div>
            :
              requests?.slice(0,3)?.map((item, index)=>(
                <div key={index} className="card card-task">
                    <div
                        className="card-body p-3 pb-1"
                        style={{ border: "1px solid lavender", borderRadius: 3 }}
                    >
                        {/* <span className="badge bg-danger">Cancelled</span> */}
                        &nbsp;
                        <span className="badge bg-primary">Lab Investigation</span>
                        <div className="d-flex align-items-center gap-2">
                            <div className="my-2">
                                <h6 className="d-block text-primary fs-sm mb-1 text-capitalize">{item?.item?.labTest?.name ? truncateText(`${item?.item?.labTest?.name}`, 40): ""}</h6>
                                <label className='fs-xs' >{moment(item?.createdAt).format("dddd, Do MMMM, YYYY")}</label>
                            </div>
                        </div>
                        <p className="fs-xs" style={{textTransform:'capitalize'}}>
                        Consultant: <a href="#"> Dr.{item?.item?.createdBy ?? "---"}</a>
                        </p>
                       
                    </div>
                </div>
                )) 
           }

    </Col>
  )
}

export default LabRequestHistorySidebar